var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-page"},[(_vm.title)?_c('demo-header',{attrs:{"title":_vm.title}}):_vm._e(),_c('div',{staticClass:"demo-page__main",style:(!_vm.title ? 'top: 0' : '')},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }